import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { CMS_LANGUAGE_IDS } from 'umg-ember-backend/utils/cms-languages';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  cmsLanguageId: validator('inclusion', { in: CMS_LANGUAGE_IDS }),
  name: validator('presence', true),
  legalContext: [validator('belongs-to'), validator('presence', true)],
});

export const settings = {
  variantProperties: ['cmsLanguageId', 'cmsState', 'name', 'text'],
};

export default class ChannelModel extends Model.extend(Validations) {
  @attr('array') activeLanguages;
  @attr('string') belonging;
  @attr('string') defaultLanguage;
  @attr('boolean') disableChannelInheritance;
  @attr('string') name;
  @attr('array') originalLanguageContents;
  @attr('string') text;
  @attr('boolean') virtual;

  // CMS fields
  @attr('string', { defaultValue: '1' }) cmsLanguageId;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('organization', { async: true, inverse: null }) legalContext;
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @belongsTo('channel', { async: true, inverse: null }) channel;
  @belongsTo('link', { async: true, inverse: null }) link;
  @hasMany('link-pattern', { async: true, inverse: null }) linkPatternDownload;
  @hasMany('link-pattern', { async: true, inverse: null }) linkPatternMedium;
  @hasMany('link-pattern', { async: true, inverse: null }) linkPatternStreaming;
  @hasMany('link-pattern', { async: true, inverse: null }) linkPatternMerch;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }
}
